import React from 'react';

import {
  SearchIntroWrapper,
  InfoHeader,
  InfoSubHeader,
  InfoBody,
  InfoTextHolder,
  BoldText,
} from './SearchIntro.styles';

const SearchIntro = () => {
  return (
    <SearchIntroWrapper>
      <InfoTextHolder>
        <InfoHeader>How to use this page:</InfoHeader>
        <InfoSubHeader>
          Here is some helpful information on how to provide great service to your customers by using the most
          up-to-date information.
        </InfoSubHeader>
        <InfoBody>
          <BoldText>Search All -</BoldText> Searches the Common Question Help. Common Question Help has the most
          up-to-date information and is most helpful in forming the base of your answer. (#ProTip - Customers love when
          you personalize these common help topics, rather than just copy and paste)
        </InfoBody>
        <InfoBody>
          <BoldText>Company Info -</BoldText> Use if you can’t find what you need in the common question help. This
          includes general company info that may be helpful when it is your first time answering a question from a new
          partner. (#ProTip - search terms to use in the ‘Search All’ section for each partner are found here)
        </InfoBody>
        <InfoBody>
          <BoldText>Search Orders -</BoldText> Order details, tracking information, etc. will be found in this section.
        </InfoBody>
      </InfoTextHolder>
    </SearchIntroWrapper>
  );
};

export default SearchIntro;
